import { useCallback, useMemo, useState } from "react";
import { SearchFormReturnType as HotelsSearchFormReturnType } from "../../hooks/useHotelsSearchForm";
import { SearchFormReturnType as PackagesSearchFormReturnType } from "../../hooks/packages/usePackagesSearchForm";
import HotelsSearchForm from "../HotelsSearchForm/HotelsSearchForm";
import PackagesSearchForm from "../PackagesSearchForm/PackagesSearchForm";
import { useAppAttributes } from "../../hooks/useAppAttributes";

interface Props {
  hotelsSearchForm: HotelsSearchFormReturnType;
  packagesSearchForm: PackagesSearchFormReturnType;
}

const HotelsSwitchableForm = ({ hotelsSearchForm, packagesSearchForm }: Props) => {
  const appAttributes = useAppAttributes();

  const [isSwitchToPackageChecked, setIsSwitchToPackageChecked] = useState(false);

  const handleFormTypeChange = useCallback(
    (isChecked: boolean) => {
      if (isChecked) {
        packagesSearchForm.setFieldsValues({
          departureAirportCode: undefined,
          departureAirportName: "",
          departureDate: hotelsSearchForm.values.checkInDate,
          returnDate: hotelsSearchForm.values.checkOutDate,
          destinationCode: hotelsSearchForm.values.locationCode,
          destinationName: hotelsSearchForm.values.locationName,
          destinationType: hotelsSearchForm.values.locationType,
          rooms: hotelsSearchForm.values.rooms,
        });
      } else {
        hotelsSearchForm.setFieldsValues({
          checkInDate: packagesSearchForm.values.departureDate,
          checkOutDate: packagesSearchForm.values.returnDate,
          locationCode: packagesSearchForm.values.destinationCode,
          locationName: packagesSearchForm.values.destinationName,
          locationType: packagesSearchForm.values.destinationType,
          rooms: packagesSearchForm.values.rooms,
        });
      }
      setIsSwitchToPackageChecked(isChecked);
    },
    [hotelsSearchForm, packagesSearchForm]
  );

  const formTypeChangeHandler = useMemo(() => {
    return appAttributes.packagesEnabled ? handleFormTypeChange : undefined;
  }, [appAttributes.packagesEnabled, handleFormTypeChange]);

  return (
    <>
      {isSwitchToPackageChecked ? (
        <PackagesSearchForm
          layout={appAttributes.layout}
          errors={packagesSearchForm.errors}
          hasErrors={packagesSearchForm.hasErrors}
          touched={packagesSearchForm.touched}
          onChange={packagesSearchForm.setFieldsValues}
          onSubmit={packagesSearchForm.handleSubmit}
          values={packagesSearchForm.values}
          isSwitchToPackageChecked={isSwitchToPackageChecked}
          onIsSwitchToPackageCheckedChange={formTypeChangeHandler}
        />
      ) : (
        <HotelsSearchForm
          layout={appAttributes.layout}
          errors={hotelsSearchForm.errors}
          hasErrors={hotelsSearchForm.hasErrors}
          touched={hotelsSearchForm.touched}
          onChange={hotelsSearchForm.setFieldsValues}
          onSubmit={hotelsSearchForm.handleSubmit}
          values={hotelsSearchForm.values}
          isSwitchToPackageChecked={isSwitchToPackageChecked}
          onIsSwitchToPackageCheckedChange={formTypeChangeHandler}
        />
      )}
    </>
  );
};

export default HotelsSwitchableForm;
